module.exports = __webpack_public_path__ + "static/media/image_02.98b6f6aa.png";